
import { defineComponent, onMounted } from 'vue';
import { AppCard, AppTable, AppButton, AppSelect, AppFormRow } from '@/components';
import { useRfmPersonaList } from '@/modules/rfm/persona/model/list';
import { ROUTE_NAME_RFM } from '@/modules/rfm/router';
import { TableColumnType, TableConfig } from '@/components/table/types';

export default defineComponent({
    name: ROUTE_NAME_RFM.PERSONA.INDEX,
    components: { AppTable, AppButton, AppSelect, AppFormRow, AppCard },
    setup() {
        const { list, total, fetchList, query, rfmGroupOptions, actions } = useRfmPersonaList();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Html, label: 'Name', htmlHandler: (row: any) => row.nameWithColor },
                { type: TableColumnType.Text, label: 'Rfm Group', key: 'groupName' },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-edit',
                        theme: 'info',
                        tooltip: 'Edit',
                        to: { name: ROUTE_NAME_RFM.PERSONA.EDIT, params: { id: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        disabled: !row.canDelete,
                        onClick: () => actions.remove(row.id)
                    })
                }
            ]
        };

        onMounted(fetchList);

        return { table, list, total, fetchList, query, rfmGroupOptions, ROUTE_NAME_RFM };
    }
});
